export default __webpack_public_path__ + "f5beea66718156407162e892babe2579.svg";